import { Button } from '@ctw/shared/components/button';
import { useUserPatientSummarizationContext } from '@ctw/shared/content/summarization/user-patient-summarization-context';
import { useCTW } from '@ctw/shared/context/ctw-context';
import { tw } from '@ctw/shared/utils/tailwind';
import { useState } from 'react';

/**
 * Internal Zus-user-only affordance to bust the server-side summary cache. Renders nothing
 * unless the active patient has a cached, completed summary AND the signed-in user is a Zus
 * employee.
 */
export const DeleteCachedSummaryButton = () => {
  const { requestContext } = useCTW();
  const { summaryResponse, deleteCachedSummary } = useUserPatientSummarizationContext();
  const [isDeleting, setIsDeleting] = useState(false);

  const isZusUser = requestContext.authTokenState.userType === 'zus';
  const hasCachedSummary =
    summaryResponse.status === 'completed' && summaryResponse.summaryJobId !== undefined;

  if (!(isZusUser && hasCachedSummary)) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="secondary"
      size="xs"
      disabled={isDeleting}
      className={tw`text-content-subtle`}
      onClick={async () => {
        setIsDeleting(true);
        try {
          await deleteCachedSummary();
        } finally {
          setIsDeleting(false);
        }
      }}
    >
      {isDeleting ? 'Deleting…' : 'Clear cache'}
    </Button>
  );
};
